import React from 'react';
import { Input, InputAdornment, InputProps } from 'tdesign-react';

import styles from './index.module.less';

export const InputAdornmentComp: React.FC<
{
  getFieldDecorator: any;
  onChange: (key: string | number) => void;
  value: any;
  btnContext: string;
  onBtnClick: (value: string[]) => void;
  valueShow?: string;
  valueType?: 'string' | 'json';
  showDrawer?: boolean;
} & InputProps
> = ({ ...props }) => (
  <div className={styles.textWrapper}>
    <InputAdornment {...props}>
      <Input {...props} />
    </InputAdornment>
  </div>
);
